<template>
    <section class="fibu-sum-collection">
        <b-row>
            <b-col cols="6" v-for="group_id in lists" :key="group_id">
                <article>
                    <h5>
                        Gruppe: {{ findGroup(group_id) }}
                        <b-button
                            variant="outline-danger"
                            class="ml-1 delete rounded-circle"
                            :size="size"
                            @click="removeFromList(group_id)"
                            ><font-awesome-icon icon="trash" />
                        </b-button>
                    </h5>
                    <FiBuSumList :group_id="group_id" :filter="filter" />
                </article>
            </b-col>
            <b-col cols="6">
                <article class="w-75 text-center mx-auto">
                    <h5>Gruppe hinzufügen</h5>
                    <p class="small">
                        Neue Summenliste aus definierten Gruppen hinzufügen
                    </p>
                    <b-input-group :size="size" class="mb-3">
                        <b-select
                            v-model="selected.group"
                            :options="group.options"
                            :disabled="group.busy"
                            :size="size"
                        ></b-select>
                        <template #append>
                            <b-button
                                :size="size"
                                :disabled="group.busy || groupAlreadyShown || selected.group === null"
                                @click="addToList"
                                >Hinzufügen</b-button
                            >
                        </template>
                    </b-input-group>
                    <p class="small font-italic">
                        Die ausgewählten Summenlisten werden pro Nutzer
                        gespeichert und das nächste mal erneut angezeigt. Es
                        können in dieser Ansicht keine Daten gelöscht werden.
                    </p>
                </article>
            </b-col>
        </b-row>
    </section>
</template>

<script>
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory.js";
import FiBuSumList from "@/components/FiBuSumList/FiBuSumList";

const FiBuGroupApi = ApiFactory.get("fibuGroup");

export default {
    name: "FiBuSumCollection",
    props: {
        filter: {
            type: Object,
            default: null
        }
    },
    mixins: [Size],
    components: {
        FiBuSumList
    },
    data() {
        return {
            lists: [],
            group: {
                busy: false,
                items: [],
                options: []
            },
            selected: {
                group: null
            }
        };
    },
    computed: {
        groupAlreadyShown() {
            return this.lists.includes(this.selected.group);
        },
        storedLists() {
            const pages = this.$store.getters.getPages;
            if (pages.fibu_buchung) {
                return pages.fibu_buchung.sumLists;
            }
            return [];
        }
    },
    watch: {
        lists: {
            handler(val) {
                this.$store.dispatch("pages", {
                    fibu_buchung: {
                        sumLists: val
                    }
                });
            },
            deep: true
        }
    },
    created() {
        this.fetchGroup();
        this.getStoredSettings();
    },
    methods: {
        async fetchGroup() {
            this.group.busy = true;
            const response = await FiBuGroupApi.get();
            if (response.ok) {
                this.group.items = response.json.collection;
                this.group.options = response.json.collection.map(item => {
                    return {
                        text: item.description,
                        value: item.id
                    };
                });
                this.group.options.unshift({
                    text: "Gruppe auswählen...",
                    value: null
                });
            }
            this.group.busy = false;
        },
        getStoredSettings() {
            this.lists = this.storedLists;
        },
        addToList() {
          this.lists.push(this.selected.group);
          this.selected.group = null;
        },
        removeFromList(id) {
            this.lists = this.lists.filter(groupId => groupId != id);
        },
        findGroup(groupId) {
            const result = this.group.items.find(el => el.id === groupId);
            if (result) {
                return `${result.description}`;
            } else {
                return groupId;
            }
        }
    }
};
</script>
